/**
 * MODEL ZipCode
 *
 * Un elemento de `data.neighborhoods` de la API de códigos postales (Copomex),
 * que expone el catálogo de SEPOMEX.
 *
 * ⚠️ COLISIÓN DE NOMBRES ENTRE APIS ⚠️
 * Copomex llama "neighborhoods" a las COLONIAS (asentamientos de SEPOMEX).
 * En CradleResident, `Neighborhood` (neighborhood.model.ts) es el CONJUNTO
 * RESIDENCIAL —el fraccionamiento completo con sus propiedades, cuentas y
 * licencias—. No son lo mismo y no se deben mezclar:
 *
 *   - Copomex  → neighborhoods[] = colonias  → este modelo, ZipCode
 *   - CradleResident → Neighborhood = conjunto residencial
 *
 * Por eso este modelo NO se llama `Neighborhood` ni nada parecido, y por eso
 * el servicio que lo consume devuelve `ZipCode[]` y no toca `Neighborhood`.
 *
 * NOTA sobre los nombres de los campos: son EXACTAMENTE los que devuelve la
 * API (verificado en vivo contra el endpoint). No se abrevian ni se renombran;
 * cualquier diferencia de escritura hace que el campo llegue en `undefined`
 * sin ningún error visible.
 */
export interface IZipCode {
  zipCode: string;
  neighborhood: string;
  neighborhoodType: string;
  municipality: string;
  state: string;
  city: string;
  idZipCode: string;
  idState: string;
  idOffice: string;
  idNeighborhood: string;
  idMunicipality: string;
  idAsentaCpcons: string;
  zone: string;
  idCity: string;
}

export class ZipCode {
  zipCode: string;
  neighborhood: string;
  neighborhoodType: string;
  municipality: string;
  state: string;
  city: string;
  idZipCode: string;
  idState: string;
  idOffice: string;
  idNeighborhood: string;
  idMunicipality: string;
  idAsentaCpcons: string;
  zone: string;
  idCity: string;

  constructor(data: IZipCode) {
    this.zipCode = data.zipCode;
    this.neighborhood = data.neighborhood;
    this.neighborhoodType = data.neighborhoodType;
    this.municipality = data.municipality;
    this.state = data.state;
    this.city = data.city;
    this.idZipCode = data.idZipCode;
    this.idState = data.idState;
    this.idOffice = data.idOffice;
    this.idNeighborhood = data.idNeighborhood;
    this.idMunicipality = data.idMunicipality;
    this.idAsentaCpcons = data.idAsentaCpcons;
    this.zone = data.zone;
    this.idCity = data.idCity;
  }
}
